import {
  AppBrandLink,
  AppNavigationHeader,
  AppNavigation as AppNavigationPhase1,
  useIsFoundationalPillarsNavPhase1Enabled,
  useIsSearchNavPhase1Enabled,
} from '@ms/yammer-features-app-navigation';
import AppNavigation from '@ms/yammer-web-components/dist/navigation/AppNavigation';
import NavigationCommunities from '@ms/yammer-web-components/dist/navigation/NavigationCommunities';
import AutocompleteAriaHost from '@ms/yammer-web-core-ui/dist/components/AutocompleteAriaHost';
import { useUIFeatures } from '@ms/yammer-web-ui-features/dist/features';
import { useIsTeamsPersonalApp } from 'hooks/selectors';
import React, { ReactNode, useCallback } from 'react';

import AppSearchNavPhase1 from '../../AppSearchNavPhase1';
import VivaSuiteNav from '../../VivaSuiteNav';

import { useHomeLinkActionButtons } from './useHomeLinkActionButtons';
import { useUserProfileLinkActionButtons } from './useUserProfileLinkActionButtons';

type UseLeftSidebarCallback = () => () => ReactNode;
export const useLeftSidebarCallback: UseLeftSidebarCallback = () => {
  const isLeftSidebarEnabled = useUIFeatures((features) => features.navigation?.leftSidebar);
  const isFoundationalPillarsNavPhase1Enabled = useIsFoundationalPillarsNavPhase1Enabled();
  const homeLinkActionButtons = useHomeLinkActionButtons();
  const userProfileLinkActionButtons = useUserProfileLinkActionButtons();
  const isSearchNavPhase1Enabled = useIsSearchNavPhase1Enabled();
  const isTeamsPersonalApp = useIsTeamsPersonalApp();

  return useCallback(() => {
    const searchInput = isSearchNavPhase1Enabled ? (
      <AutocompleteAriaHost>
        <AppSearchNavPhase1 />
      </AutocompleteAriaHost>
    ) : null;
    const vivaSuiteNav = isTeamsPersonalApp ? <VivaSuiteNav /> : null;
    const navigationContent = isFoundationalPillarsNavPhase1Enabled ? (
      <AppNavigationPhase1
        communitiesNavLinksContent={<NavigationCommunities />}
        header={<AppNavigationHeader title={<AppBrandLink />} contextMenu={vivaSuiteNav} searchInput={searchInput} />}
        homeLinkActionButtons={homeLinkActionButtons}
        userProfileLinkActionButtons={userProfileLinkActionButtons}
      />
    ) : (
      <AppNavigation />
    );

    return isLeftSidebarEnabled ? navigationContent : null;
  }, [
    homeLinkActionButtons,
    isFoundationalPillarsNavPhase1Enabled,
    isLeftSidebarEnabled,
    userProfileLinkActionButtons,
    isSearchNavPhase1Enabled,
    isTeamsPersonalApp,
  ]);
};
